/**
 * The vendor's announcements (container, phase 7b item 5): the list, live
 * through the `announcement` change kind; "new" opens the editor in create
 * mode (`/vendor/announcements/new`).
 */
import { useNavigate } from '@tanstack/react-router';
import { useNow, useVendorAnnouncements } from '../app/hooks.js';
import { announcementHref, AnnouncementsList } from '../components/vendor/AnnouncementsList.js';
import { useVendorAdmin } from './VendorLayout.js';

function messageOf(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}

/** The editor's path segment for a new announcement (a ULID is never this). */
export const NEW_ANNOUNCEMENT = 'new';

export function VendorAnnouncementsView() {
  const list = useVendorAnnouncements();
  const canAdmin = useVendorAdmin();
  const now = useNow(30_000);
  const navigate = useNavigate();
  return (
    <AnnouncementsList
      announcements={list.data ?? []}
      loading={list.isFetching}
      error={list.error === null ? null : messageOf(list.error)}
      canAdmin={canAdmin}
      nowMs={now}
      onCreate={() => void navigate({ to: announcementHref(NEW_ANNOUNCEMENT) })}
      onOpen={(id) => void navigate({ to: announcementHref(id) })}
      onRetry={() => void list.refetch()}
    />
  );
}
